import { useContext } from 'react';
import MapContext from '../controller/MapProvider';
import { mapStaticVariables } from '../model/StaticVariables';
import { useEffect } from 'react';
import { useState } from 'react';

export default function AdminControls() {
    const { setZoom, map } = useContext(MapContext);
    const [localZoom, setLocalZoom] = useState(2);
    const [localCenter, setLocalCenter] = useState(mapStaticVariables.coordinates.usCenter3857);
    const changeZoom = (e) => {
        setZoom(e.target.value);
    };
    const updateUI = (e) => {
        var zoom = map.getView().getZoom();
        var center = map.getView().getCenter();
        setLocalZoom(zoom);
        setLocalCenter(center);
    };
    // useeffectmap, if map isn't null
    // add a listener to the map to listen to centerchange or zoom change
    useEffect(() => {
        if (!map) return;
        map.on('moveend', updateUI);
        return () => {
            map.un('movend', updateUI);
        };
    }, [map]);
    return (
        <div id="adminPanel">
            <div className="field">
                <label>Center:</label>
                <label className={'val'}> {localCenter.join(' ')} </label>
            </div>
            <div className="field">
                <label>Zoom:</label>
                <label className={'val'}>{localZoom}</label>
            </div>
            <div className="field">
                <label>Set Zoom</label>
                <input onKeyDown={(e) => e.key === 'Enter' && changeZoom(e)} />
            </div>
        </div>
    );
}
